import {
  CLEAN_GLOBAL_SEARCH_CONVERSATIONS,
  CLEAN_MESSAGING_ACCIDENTS,
  CLEAR_CONVERSATION_MODEL,
  CREATE_CONVERSATION,
  GET_CONVERSATION_MODEL,
  GET_CONVERSATIONS,
  GET_MESSAGING_ACCIDENTS,
  GET_PENDING_MESSAGING_COUNT,
  DECREMENT_PENDING_MESSAGING_COUNT,
  GLOBAL_SEARCH_CONVERSATIONS,
  REOPEN_CONVERSATION,
  SEND_MESSAGE,
} from "../actions/messaging";

const initialState = {
  pendingCount: 0,
  model: {
    data: { tipos: [] },
    isLoading: false,
    isError: false,
  },
  creation: {
    data: {},
    isLoading: false,
    isError: false,
  },
  conversations: {
    data: [],
    isLoading: false,
    isError: false,
  },
  sendingMessage: {
    isLoading: false,
    isError: false,
  },
  globalSearch: {
    data: [],
    isLoading: false,
    isError: false,
  },
  accidents: {
    data: [],
    isLoading: false,
    isError: false,
  },
};

const messagingReducer = (state = initialState, action) => {
  switch (action.type) {
    case DECREMENT_PENDING_MESSAGING_COUNT:
      return {
        ...state,
        pendingCount: Math.max(0, state.pendingCount - action.payload),
      };
    case `${GET_PENDING_MESSAGING_COUNT}_FULFILLED`:
      return {
        ...state,
        pendingCount: action.payload,
      };
    case `${GET_CONVERSATION_MODEL}_PENDING`:
      return {
        ...state,
        model: {
          ...state.model,
          isLoading: true,
          isError: false,
        },
      };
    case `${GET_CONVERSATION_MODEL}_FULFILLED`:
      return {
        ...state,
        model: {
          data: action.payload.data,
          isLoading: false,
          isError: false,
        },
      };
    case `${GET_CONVERSATION_MODEL}_REJECTED`:
      return {
        ...state,
        model: {
          ...state.model,
          isLoading: false,
          isError: true,
        },
      };
    case CLEAR_CONVERSATION_MODEL:
      return {
        ...state,
        model: {
          data: { tipos: [] },
          isLoading: false,
          isError: false,
        },
        creation: {
          data: {},
          isLoading: false,
          isError: false,
        },
      };
    case `${CREATE_CONVERSATION}_PENDING`:
      return {
        ...state,
        creation: {
          ...state.creation,
          isLoading: true,
          isError: false,
        },
      };
    case `${CREATE_CONVERSATION}_FULFILLED`:
      return {
        ...state,
        creation: {
          data: action.payload,
          isLoading: false,
          isError: false,
        },
      };
    case `${CREATE_CONVERSATION}_REJECTED`:
      return {
        ...state,
        creation: {
          ...state.creation,
          isLoading: false,
          isError: true,
        },
      };
    case `${GET_CONVERSATIONS}_PENDING`:
      return {
        ...state,
        conversations: {
          ...state.conversations,
          isLoading: true,
          isError: false,
        },
      };
    case `${GET_CONVERSATIONS}_FULFILLED`:
      return {
        ...state,
        conversations: {
          data: action.payload.data,
          isLoading: false,
          isError: false,
        },
      };
    case `${GET_CONVERSATIONS}_REJECTED`:
      return {
        ...state,
        conversations: {
          ...state.conversations,
          isLoading: false,
          isError: true,
        },
      };
    case `${SEND_MESSAGE}_PENDING`:
    case `${REOPEN_CONVERSATION}_PENDING`:
      return {
        ...state,
        sendingMessage: {
          isLoading: true,
          isError: false,
        },
      };
    case `${SEND_MESSAGE}_FULFILLED`:
    case `${REOPEN_CONVERSATION}_FULFILLED`:
      return {
        ...state,
        sendingMessage: {
          isLoading: false,
          isError: false,
        },
      };
    case `${SEND_MESSAGE}_REJECTED`:
    case `${REOPEN_CONVERSATION}_REJECTED`:
      return {
        ...state,
        sendingMessage: {
          isLoading: false,
          isError: true,
        },
      };
    case `${GLOBAL_SEARCH_CONVERSATIONS}_PENDING`:
      return {
        ...state,
        globalSearch: {
          ...state.globalSearch,
          isLoading: true,
          isError: false,
        },
      };
    case `${GLOBAL_SEARCH_CONVERSATIONS}_FULFILLED`:
      return {
        ...state,
        globalSearch: {
          data: action.payload.data,
          isLoading: false,
          isError: false,
        },
      };
    case `${GLOBAL_SEARCH_CONVERSATIONS}_REJECTED`:
      return {
        ...state,
        globalSearch: {
          ...state.globalSearch,
          isLoading: false,
          isError: true,
        },
      };
    case CLEAN_GLOBAL_SEARCH_CONVERSATIONS:
      return {
        ...state,
        globalSearch: {
          data: [],
          isLoading: false,
          isError: false,
        },
      };
    case `${GET_MESSAGING_ACCIDENTS}_PENDING`:
      return {
        ...state,
        accidents: {
          ...state.accidents,
          isLoading: true,
          isError: false,
        },
      };
    case `${GET_MESSAGING_ACCIDENTS}_FULFILLED`:
      return {
        ...state,
        accidents: {
          data: action.payload.data,
          isLoading: false,
          isError: false,
        },
      };
    case `${GET_MESSAGING_ACCIDENTS}_REJECTED`:
      return {
        ...state,
        accidents: {
          ...state.accidents,
          isLoading: false,
          isError: true,
        },
      };
    case CLEAN_MESSAGING_ACCIDENTS:
      return {
        ...state,
        accidents: {
          data: [],
          isLoading: false,
          isError: false,
        },
      };
    default:
      return state;
  }
};

export default messagingReducer;
